jQuery( document ).ready(function() {
    // Check if component is added to the page
    if( jQuery('section.homepage-signpost-slider').length ) {
        let $ = jQuery;

        let $width = 0;

        const $slider = $(".homepage-signpost-slider .signpost-slider");
        let $slide = $(".homepage-signpost-slider .signpost-slider .sp-slide");

        $(window).on("resize", function () {
                $slider.css({
                    'position':      'relative',
                    'transform':     'translateX(0px)'
                });
        });


        $slide.on("click mouseenter", function () {
           let $activeSlides = $(".homepage-signpost-slider .signpost-slider .sp-slide.active");
           let $newBackground = $(this).data('background');
           let $slideClass = $(this).data('slide_num');

           if($(window).width() < 992) { //we need to reposition the slides
               $modifier = 1200 / $(window).width();
               $fitOnScreen = $(window).width() / 300;
               $itemWidth = $(this).outerWidth();
               $maxWidth = 1200 - ($itemWidth * $fitOnScreen);
               $index = $(this).data('slide_index');
               if($index == 0) {
                   $width = $itemWidth * $index;
               } else if($index == 3) {
                   $width = 1200 - ($itemWidth * $fitOnScreen);
               } else {
                   $width = ($itemWidth * $index) - 25;
                   if($width > $maxWidth) {
                       $width = $maxWidth;
                   }
               }

               $slider.attr('data-current_slide', $index).css({
                   'position':      'relative',
                   'transform':     'translateX(-'+$width+'px)'
               });
           }

           $(".homepage-signpost-slider .signpost-slider .bg-image").css('background-image', 'url('+$newBackground+')');
           $(".homepage-signpost-slider .signpost-slider .bg-image").removeClass('slide-0 slide-1 slide-2 slide-3');
           $(".homepage-signpost-slider .signpost-slider .bg-image").addClass($slideClass);
           $activeSlides.removeClass('active');
           $(this).addClass('active');
        });


        $("#sp-slide-0").trigger("click").click();


        function moveToSlide($index) {
            let $modifier = 1200 / $(window).width();
            let $fitOnScreen = $(window).width() / 300;
            let $itemWidth = 300;
            let $maxWidth = 1200 - ($itemWidth * $fitOnScreen);

            if($index == 0) {
                $width = $itemWidth * $index;
            } else if($index == 3) {
                $width = 1200 - ($itemWidth * $fitOnScreen);
            } else {
                $width = ($itemWidth * $index) - 25;
                if($width > $maxWidth) {
                    $width = $maxWidth;
                }
            }
            $slider.attr('data-current_slide', $index).css({
                'position':      'relative',
                'transform':     'translateX(-'+$width+'px)'
            });
            let $activeSlides = $(".homepage-signpost-slider .signpost-slider .sp-slide.active");
            let $newBackground = $("#sp-slide-"+$index).data('background');
            let $slideClass = $("#sp-slide-"+$index).data('slide_num');

            $(".homepage-signpost-slider .signpost-slider .bg-image").css('background-image', 'url('+$newBackground+')');
            $(".homepage-signpost-slider .signpost-slider .bg-image").removeClass('slide-0 slide-1 slide-2 slide-3');
            $(".homepage-signpost-slider .signpost-slider .bg-image").addClass($slideClass);
            $activeSlides.removeClass('active');
            $("#sp-slide-"+$index).addClass('active');

        }

        const slider = document.getElementById('hammer-signpost-slider');
        let hammer = new Hammer(slider);
        var currSlide;

        hammer.on("swipe", function (e) {
            currSlide = $slider.attr('data-current_slide');
            var nextSlide = 0;
            if($(window).width() <= 992) {
                if (e.direction == 2) {
                    if(currSlide == 0) {
                        nextSlide = 1;
                    } else if (currSlide == 3) {
                        nextSlide = 3;
                    } else {
                        nextSlide = parseInt(currSlide) + 1;
                    }
                } else if (e.direction == 4) {
                    if(currSlide == 0) {
                        nextSlide = 0;
                    } else if (currSlide == 3) {
                        nextSlide = 2;
                    } else {
                        nextSlide = parseInt(currSlide) - 1;
                    }
                }
                moveToSlide(nextSlide);
            }
        });


    }
});